import React from 'react';
import {ButtonToolbar, ButtonGroup, Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as R from 'ramda';

export default function ShippingButtons(props) {
    const {active, shippingSupportUrl, shippingNoPostUrl} = props;

    return (
        <ButtonToolbar>
            <ButtonGroup bsSize="large">
                <Button active={R.equals(shippingSupportUrl, active)} href={shippingSupportUrl}>
                    Shipping Support
                </Button>
                <Button active={R.equals(shippingNoPostUrl, active)} href={shippingNoPostUrl}>
                    Shipping No Post
                </Button>
            </ButtonGroup>
        </ButtonToolbar>
    );
}

ShippingButtons.displayName = 'ShippingButtons';

ShippingButtons.propTypes = {
    active: PropTypes.string,
    shippingSupportUrl: PropTypes.string.isRequired,
    shippingNoPostUrl: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/shipping_buttons.js